import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CartService {
  // private cartItems = new BehaviorSubject<any[]>([]);
  // private cartItemCount = new BehaviorSubject<number>(0);

  // cartItems$ = this.cartItems.asObservable();
  // cartItemCount$ = this.cartItemCount.asObservable();

  // constructor() { }

  // getCartItems(): any[] {
  //   return this.cartItems.value;
  // }

  // getCartItemCount(): number {
  //   return this.cartItemCount.value;
  // }

  // addToCart(item: any): void {
  //   const currentItems = this.cartItems.value;
  //   const existingItem = currentItems.find(cartItem => cartItem.id === item.id);
    
  //   if (existingItem) {
  //     existingItem.quantity += item.quantity;
  //   } else {
  //     currentItems.push({
  //       ...item,
  //       quantity: item.quantity
  //     });
  //   }
    
  //   this.cartItems.next([...currentItems]);
  //   this.updateCartItemCount();
  // }

  // removeFromCart(index: number): void {
  //   const currentItems = this.cartItems.value;
  //   currentItems.splice(index, 1);
  //   this.cartItems.next([...currentItems]);
  //   this.updateCartItemCount();
  // }

  // updateQuantity(index: number, quantity: number): void {
  //   if (quantity > 0) {
  //     const currentItems = this.cartItems.value;
  //     currentItems[index].quantity = quantity;
  //     this.cartItems.next([...currentItems]);
  //     this.updateCartItemCount();
  //   }
  // }

  // clearCart(): void {
  //   this.cartItems.next([]);
  //   this.cartItemCount.next(0);
  // }

  // private updateCartItemCount(): void {
  //   const totalItems = this.cartItems.value.reduce((total, item) => total + item.quantity, 0);
  //   this.cartItemCount.next(totalItems);
  // }

  public cartItems = new BehaviorSubject<any[]>([]);
private cartItemCount = new BehaviorSubject<number>(0);
private readonly STORAGE_KEY = 'cart_items';

cartItems$ = this.cartItems.asObservable();
cartItemCount$ = this.cartItemCount.asObservable();

constructor() {
  this.loadCartFromStorage();
}

/* GET ALL CART ITEMS */
getCartItems(): any[] {
  return this.cartItems.value;
}

/* GET UNIQUE PRODUCT COUNT */
getCartItemCount(): number {
  return this.cartItemCount.value;
}

/* ADD TO CART */
addToCart(item: any): void {

  const currentItems = [...this.cartItems.value];

  const existingItem = currentItems.find(
    cartItem => cartItem.id === item.id
  );

  if (existingItem) {

    /* MERGE QUANTITY */
    existingItem.quantity += item.quantity;

  } else {

    currentItems.push({
      ...item,
      quantity: item.quantity || 1
    });

  }

  this.cartItems.next(currentItems);

  this.updateCartItemCount();

  this.saveCartToStorage();
}

/* REMOVE ITEM */
removeFromCart(index: number): void {

  const currentItems = [...this.cartItems.value];

  currentItems.splice(index, 1);

  this.cartItems.next(currentItems);

  this.updateCartItemCount();

  this.saveCartToStorage();
}

/* UPDATE QUANTITY */
updateQuantity(index: number, quantity: number): void {

  if (quantity > 0) {

    const currentItems = [...this.cartItems.value];

    currentItems[index].quantity = quantity;

    this.cartItems.next(currentItems);

    this.updateCartItemCount();

    this.saveCartToStorage();
  }
}

/* CLEAR CART */
clearCart(): void {

  this.cartItems.next([]);

  this.cartItemCount.next(0);

  this.saveCartToStorage();
}

/* UPDATE UNIQUE PRODUCT COUNT */
private updateCartItemCount(): void {

  /* UNIQUE PRODUCTS COUNT */
  const totalProducts = this.cartItems.value.length;

  this.cartItemCount.next(totalProducts);
}

/* SAVE CART TO LOCAL STORAGE */
private saveCartToStorage(): void {
  try {
    const cartData = this.cartItems.value;
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(cartData));
  } catch (error) {
    console.error('Error saving cart to storage:', error);
  }
}

/* LOAD CART FROM LOCAL STORAGE */
private loadCartFromStorage(): void {
  try {
    const storedCart = localStorage.getItem(this.STORAGE_KEY);
    if (storedCart) {
      const cartData = JSON.parse(storedCart);
      this.cartItems.next(cartData);
      this.updateCartItemCount();
    }
  } catch (error) {
    console.error('Error loading cart from storage:', error);
  }
}



}
